import React, { useEffect, useState } from 'react';
import { Grid } from '@nextiva/next-ui-components';
import { SwitchWrapper } from 'components/Switch';

import { EDIT_ROLE, CLONE_ROLE, CREATE_ROLE } from 'constants/drawerTitles';
import { formatToTestId } from 'utils/validators';

const Permission = ({
  children,
  macro,
  macro: { name, description, parent },
  onPermissionChange,
  drawerTitle,
}) => {
  const [checked, setChecked] = useState(parent);
  const [disabled, setDisabled] = useState(false);
  const formattedName = formatToTestId(name);
  const formattedDescription = formatToTestId(description);

  useEffect(() => {
    if (parent) setChecked(true);
    else setChecked(false);
    if (
      drawerTitle !== EDIT_ROLE &&
      drawerTitle !== CLONE_ROLE &&
      drawerTitle !== CREATE_ROLE
    ) {
      setDisabled(true);
    }
  }, [parent]);

  const handleChange = (event) => {
    const bool = event.target.checked;
    setChecked(bool);
    // Handle single toggle permissions
    if (macro.type === 'toggle' && macro.toggles.length === 1) {
      const [toggles] = macro.toggles;
      const [key] = Object.keys(toggles);

      onPermissionChange({ [key]: bool });

      return;
    }

    onPermissionChange(bool);
  };

  return (
    <Grid
      className="m-role-form__role-permission"
      data-testid="PlatformAdminUI-RolesAndPermissions-Permission-RoleFormPermission"
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        className="m-role-form__role-parent"
      >
        <Grid item>
          <div
            className="m-role-form__role-title"
            data-testid={`PlatformAdminUI-RolesAndPermissions-Permission-RoleTitle-${formattedName}`}
          >
            {name}
          </div>
          <div
            className="m-role-form__role-subtitle"
            data-testid={`PlatformAdminUI-RolesAndPermissions-Permission-RoleSubTitle-${formattedDescription}`}
          >
            {description}
          </div>
        </Grid>
        <Grid item>
          <SwitchWrapper
            checked={checked}
            onChange={handleChange}
            className={`m-role-form__role-switcher--${checked ? 'on' : 'off'}`}
            disabled={disabled}
            data-testid={`PlatformAdminUI-RolesAndPermissions-Permission-${formattedName}-toggle`}
          />
        </Grid>
      </Grid>
      {children}
    </Grid>
  );
};

export default Permission;
